import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { paddingLeft, pageTitle } from '@styles/utils';

export const Wrapper = styled.div`
  padding-top: 78px;
  padding-bottom: 200px;
  ${media.largeScreen`
    padding-top: 71px;
    padding-bottom: 110px;
  `}
  ${media.mediumScreen`
    padding-top: 42px;
    padding-bottom: 120px;
  `}
  ${media.smallScreen`
    padding-top: 40px;
    padding-bottom: 90px;
  `}
`;

export const Header = styled(Container)`
  ${paddingLeft}
`;

export const Content = styled(Container)``;

export const Title = styled.h2`
  ${pageTitle}
`;
